
import { Vue, Component, Prop } from 'vue-property-decorator';
import CreateGroupConversationModal from '@/components/inbox/CreateGroupConversationModalNew.vue';
import UiButton from '@/components/button/ui-button.vue';
import MessageIcon from "@/components/icons/InboxIcon.vue";
import MessageIconHover from "@/components/icons/InboxIconHover.vue";
import ConversationUserDataForModal from '@/entities/ConversationUserDataForModal';
import Roles from '@/entities/Roles';
import { Project, User } from '@/generated/graphql';

@Component({
	components: {
		CreateGroupConversationModal,
		UiButton,
		MessageIcon,
		MessageIconHover
	},
})
export default class MessageAction extends Vue {
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Object, required: true }) readonly project!: Project;
	@Prop({ type: String, required: true }) readonly companyId!: string;

	modalShown: boolean = false;
	isHovered: boolean = false;

	get hasParticipants(): boolean {
		return this.projectUsers.length > 0;
	}

	get projectUsers(): ConversationUserDataForModal[] {
		const { project_activities: activities } = this.project;
		const manager = this.project.manager?.user;

		if (!activities.length && !manager) {
			return [];
		}

		const uniqueIds = new Set();

		const uniqueUsers = activities.reduce(
			(arr: ConversationUserDataForModal[], { contractor }) => {
				const user = contractor?.user;
				if (!user) {
					return arr;
				}
				const currentStepContractors: ConversationUserDataForModal[] =
					[];

				if (!uniqueIds.has(user.id)) {
					currentStepContractors.push({
						userId: user.id,
						avatar: user.avatar,
						name: `${user.given_name} ${user.family_name}`,
					});
					uniqueIds.add(user.id);
				}

				return arr.concat(currentStepContractors);
			},
			[]
		);

		if (!manager || this.currentUser.role === Roles.MANAGER) {
			return uniqueUsers;
		}

		return [
			...uniqueUsers,
			{
				userId: manager.id,
				avatar: manager.avatar,
				name: `${manager.given_name} ${manager.family_name} (manager)`,
			},
		];
	}

	showModal(): void {
		this.modalShown = true;
	}
}
